<div class="container" id="home-container">
  <div class="header">
    <span id="home-header-title">{{ 'HOME.TITLE' | translate }}</span>
  </div>
  <div class="card" id="routing-protocol-card">
    <div class="track-icon">
      <img src="images/icon-track.svg" alt="logo" />
    </div>
    <div class="card-body">
      <div class="card-title"><span id="routing-protocol-card-title">{{ 'ROUTING_PROTOCOL.TITLE' | translate }}</span></div>
   
    <ul id="routing-protocol-tabs">
      @for (tab of tabs(); track tab.label) {
        <li
          [id]="'tab-item-' + tab.label.toLowerCase().replace('.', '-')"
          [ngClass]="{
            'active': !tab.disabled,
            'disable': tab.disabled
          }"
        >
          <a
            [id]="'tab-link-' + tab.label.toLowerCase().replace('.', '-')"
            (click)="!tab.disabled && changeTab($index)"
            (keyup.enter)="!tab.disabled && changeTab($index)"
            tabindex="0"
          >
            {{ tab.label | translate }}
          </a>
        </li>
      }
    </ul>
    </div>
  </div>
</div>